export default {
    props: {
        form: {
            default() {

                let vm = this;

                while (vm.$parent) {

                    vm = vm.$parent;

                    if (vm.form) {
                        return vm.form;
                    }

                    if (vm.hasOwnProperty('form') || (vm.hasOwnProperty('$props') && vm.$props.hasOwnProperty('form'))) {
                        return vm.form;
                    }

                    if (vm.data && vm.data.hasOwnProperty('form')) {
                        return vm.data.form;
                    }
                }
            }
        }
    }
}
